import React from 'react';

export function ProfilePicture({ user, size = 36, theme }) {
  const fallbackBg = user?.color || theme?.coral || '#FF5A4E';
  const initial = (user?.name || '?').charAt(0).toUpperCase();

  if (user?.photoUrl) {
    return (
      <img
        src={user.photoUrl}
        alt={user.name || ''}
        style={{
          width: size, height: size,
          borderRadius: '50%',
          objectFit: 'cover',
          display: 'block',
        }}
      />
    );
  }

  return (
    <div style={{
      width: size, height: size,
      borderRadius: '50%',
      background: fallbackBg,
      color: 'white',
      fontWeight: 700,
      fontSize: size * 0.42,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}>{initial}</div>
  );
}
